import auth from "@/helper/middleware/auth";
export default [
  {
    path: "/requests",
    name: "submission",
    component: () => import("@/views/submission/SubmissionView.vue"),
    meta: { middleware: [auth] },
  },
];
